var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuckleSize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2240",
  d: "M25.215 34.218a1.68 1.68 0 0 0-1.715 1.698V48.86c0 1.094.525 2.504 2.88 3.624.411.14.88.354 1.413.512 2.321.636 4.72.94 7.127.907 2.41.034 4.813-.27 7.137-.906a8.6 8.6 0 0 0 1.41-.517q.639-.286 1.216-.683a3.65 3.65 0 0 0 1.733-2.826l.035-13.049a1.726 1.726 0 0 0-1.768-1.697zM41.9 48.209a16.6 16.6 0 0 1-6.94 1.155c-3.799 0-6.17-.717-6.937-1.14v-9.472l4.603-.001.008 5.223a2.266 2.266 0 1 0 4.533 0l.001-5.215h4.743z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "m45.132 30.725-1.143-1.142 3.712-3.72-3.712-3.72L45.132 21l4.863 4.862z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "M48.987 26.612H33.993v-1.5h14.994zM23.862 30.725l1.143-1.142-3.713-3.72 3.713-3.72L23.862 21l-4.863 4.863z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "M35 26.612H20.007v-1.5h14.995z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h70v70H0z"
})))));
export { SvgBuckleSize as ReactComponent };
export default "/_next/static/images/buckle-size.svg";